import Slider from "@mui/material/Slider";
import styles from "./styles";
import useStyles from "@hooks/useStyle";
import { MvSliderPropsInterface } from "@mv-components/types";

const SliderRange = (props: MvSliderPropsInterface) => {
	const { classes } = useStyles(styles);
	const { value, defaultValue, min, max, onChange = () => {}, itemKey, labelFormatter } = props;

	const masks = [min, max];

	const handleLabelFormatting = (value: number) => {
		if (labelFormatter) {
			return labelFormatter(value);
		}
		return value;
	};

	const handleChange = (event: Event, value: number | number[]) => {
		onChange({ itemKey, event, value });
	};

	return (
		<Slider
			classes={classes}
			min={Number(min.value)}
			max={Number(max.value)}
			value={value}
			defaultValue={defaultValue}
			onChange={handleChange}
			valueLabelDisplay="auto"
			aria-labelledby="range-slider"
			valueLabelFormat={handleLabelFormatting}
			marks={masks}
			step={1}
		/>
	);
};

export default SliderRange;
